import i18n from "../../../../constants/i18n";
import { AUDITED_EVENTS_COUNTS_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import getAuditedEventsStore from "../../../../stores/auditor-store/audited-events-store";

const AuditedEventsData = withLiteObserverAndTheme(() => {
  const auditedEvents = getAuditedEventsStore().adminAuditedEventsOrdered.get();

  return (
    <Et3Table
      columns={AUDITED_EVENTS_COUNTS_HEADERS}
      rows={auditedEvents}
      title={i18n.get("EVENTS_COUNT")}
      shouldBeFlagged={false}
      titleKey={"EVENTS_COUNT"}
    />
  );
});

export default AuditedEventsData;
